import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utilities/core/cn";
type TeamShieldSize = "xs" | "sm" | "md" | "lg" | "xl" | "xl2" | "xl3";
const SIZE_MAP: Record<TeamShieldSize, number> = {
  xs: 16,
  sm: 20,
  md: 32,
  lg: 48,
  xl: 64,
  xl2: 80,
  xl3: 96
};
const SHIELD_PATH = "M50 5 L90 20 L90 55 Q90 85 50 97 Q10 85 10 55 L10 20 Z";
const SPLIT_PATH = "M50 5 L90 20 L90 55 Q90 85 50 97 L50 5Z";
const BORDER_COLOR = "#B0B0B0";
const DEFAULT_PRIMARY = "#9CA3AF";
const DEFAULT_SECONDARY = "#D1D5DB";
interface TeamShieldProps {
  primaryColor?: string | null;
  secondaryColor?: string | null;
  size?: TeamShieldSize;
  className?: string;
}
export function TeamShield(t0) {
  const $ = _c(12);
  const {
    primaryColor,
    secondaryColor,
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const px = SIZE_MAP[size];
  const primary = primaryColor || DEFAULT_PRIMARY;
  const hasSecondary = secondaryColor && secondaryColor !== primaryColor;
  const secondary = hasSecondary ? secondaryColor : primaryColor ? undefined : DEFAULT_SECONDARY;
  let t2;
  if ($[0] !== className) {
    t2 = cn("shrink-0", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== primary) {
    t3 = <path d={SHIELD_PATH} fill={primary} />;
    $[2] = primary;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== secondary) {
    t4 = secondary && <path d={SPLIT_PATH} fill={secondary} />;
    $[4] = secondary;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path d={SHIELD_PATH} fill="none" stroke={BORDER_COLOR} strokeWidth="2.5" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== px || $[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t6 = <svg width={px} height={px} viewBox="8 3 84 96" className={t2} aria-hidden="true">{t3}{t4}{t5}</svg>;
    $[7] = px;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}